import { Consultorio } from '../models/Entities/Turnero';
import { buildURL } from './commons/CommonService.Functions';
import { officesApiRequest as apiRequest } from './commons/OfficesApi.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'offices/Consultorios';

export const GetConsultorios = async (token: string): Promise<Consultorio[]> => {
    return apiRequest<Consultorio[]>(BaseURL, token, 'GetConsultorios');
};

export const CreateConsultorio = async (token: string, consultorio: Consultorio): Promise<Consultorio> => {
    return apiRequest<Consultorio>(BaseURL, token, 'CreateConsultorio', {
        method: 'POST',
        body: JSON.stringify(consultorio)
    });
};

export const GetConsultoriosDisponibles = async (token: string): Promise<Consultorio[]> => {
    const requestURL = buildURL(BaseURL, 'todos-disponibles');
    return apiRequest<Consultorio[]>(requestURL, token, 'GetConsultoriosDisponibles');
};

export const GetConsultoriosDisponiblesPorDoctor = async (token: string, doctorId: string, medicoId?: number): Promise<Consultorio[]> => {
    let requestURL = buildURL(BaseURL, 'disponibles', doctorId);

    const params = new URLSearchParams();
    if (medicoId !== undefined) {
        params.append('medicoId', medicoId.toString());
    }

    if (params.toString()) {
        requestURL += '?' + params.toString();
    }

    return apiRequest<Consultorio[]>(requestURL, token, 'GetConsultoriosDisponiblesPorDoctor');
};

export const UpdateConsultorio = async (token: string, id: number, consultorio: Consultorio): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'UpdateConsultorio', {
        method: 'PUT',
        body: JSON.stringify(consultorio)
    });
};

export const DeleteConsultorio = async (token: string, id: number): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'DeleteConsultorio', {
        method: 'DELETE'
    });
};

export const UpdateEstadoConsultorio = async (token: string, id: number, estado: string): Promise<string> => {
    const requestURL = buildURL(BaseURL, id, 'estado');
    return apiRequest<string>(requestURL, token, 'UpdateEstadoConsultorio', {
        method: 'PUT',
        body: JSON.stringify(estado)
    });
};
